import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';

import { AuraAuthService } from '@digital-platform/aura-authentication/services';

@Component({
  selector: 'digital-platform-login',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  private auraAuthService = inject(AuraAuthService);

  constructor() {
    this.auraAuthService.login();
  }
}
